<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Candidates</h4>
        </div>
        <div class="card-body">
          <div class="row border-bottom border-top py-3 bg-light">
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.id"
                placeholder="ID"
              />
            </div>
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.name"
                placeholder="Name"
              />
            </div>
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.email"
                placeholder="Email"
              />
            </div>
          </div>
          <div>
            <BTable :items="users" :fields="fields" :busy="isTableBusy">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(full_name)="data">
                <router-link
                  :to="{ name: 'candidate-user', params: { userId: data.item.id } }"
                >{{ data.item.full_name }}</router-link>
              </template>
              <template v-slot:cell(email)="data">
                <router-link
                  :to="{ name: 'candidate-user', params: { userId: data.item.id } }"
                >{{ data.item.email }}</router-link>
              </template>
              <template v-slot:cell(status)="data">
                <span
                  class="badge"
                  :class="data.item.deleted_at ? 'badge-danger' : 'badge-success'"
                >{{ data.item.deleted_at ? 'Archived' : 'Active' }}</span>
              </template>
              <template v-slot:cell(actions)="data">
                <router-link
                  :to="{ name: 'candidate-user', params: { userId: data.item.id } }"
                  class="btn btn-sm btn-outline-primary mr-1"
                >View</router-link>
                <button
                  v-if="!data.item.deleted_at"
                  class="btn btn-sm btn-outline-danger"
                  @click="archiveUser(data.item)"
                >
                  <i class="fas fa-archive"></i> Archive
                </button>
                <button
                  v-else
                  class="btn btn-sm btn-outline-success"
                  @click="restoreUser(data.item)"
                >
                  <i class="fas fa-undo"></i> Restore
                </button>
              </template>
            </BTable>
            <BPagination
              :disabled="isTableBusy"
              v-model="currentPage"
              @input="fetchUsers"
              :total-rows="total"
              :per-page="perPage"
              align="center"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BPagination, BFormInput } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BSpinner,
    BPagination,
    BFormInput
  },
  data() {
    return {
      filters: {
        id: null,
        name: null,
        email: null
      },
      users: [],
      currentPage: 1,
      perPage: 10,
      total: 0,
      isTableBusy: true,
      fields: [
        "id",
        { key: "full_name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "city", label: "City" },
        { key: "created_at", label: "Created" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" }
      ]
    };
  },
  methods: {
    applyFilters() {
      this.currentPage = 1;
      this.fetchUsers();
    },
    fetchUsers() {
      this.isTableBusy = true;
      this.$http
        .get("/enroll_admin/jobboard-users", {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            filters: this.filters
          }
        })
        .then(({ data }) => {
          this.currentPage = data.current_page;
          this.total = data.total;
          this.users = data.data;
        })
        .finally(() => (this.isTableBusy = false));
    },
    archiveUser(user) {
      if (!confirm(`Archive user "${user.full_name}"? They will no longer be able to log in.`)) return;
      this.$http
        .post(`/enroll_admin/jobboard-users/${user.id}/archive`)
        .then(() => this.fetchUsers());
    },
    restoreUser(user) {
      if (!confirm(`Restore user "${user.full_name}"?`)) return;
      this.$http
        .post(`/enroll_admin/jobboard-users/${user.id}/restore`)
        .then(() => this.fetchUsers());
    }
  },
  created() {
    this.fetchUsers();
  }
};
</script>
